import { createTheme } from "@mui/material";

import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const theme = createTheme();

theme.typography.h6 = {
  fontSize: "1rem",
  "@media (min-width:600px)": {
    fontSize: "1rem",
    fontWeight: 100,
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "1rem",
    fontWeight: 200,
    color: "1B1C1D",
  },
};

interface Props {
  claimId: string;
}
export const Confirmation: React.FC<Props> = ({ claimId }) => {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <h2 className="subheader">{t('ConfirmationHeading')}</h2>

      <div className="formLabel">
        <strong>{t('YourClaimNumberIs')} {claimId}.</strong>
      </div>

      <div className="description">
        <br/>{t('ConfirmationDescription')}<br/>
      </div>

      <h3 className="formLabel">{t('WhatToExpect')}</h3>

      <div className="description">
        {t('ConfirmationDocument')} <a
        href={"mailto:claimdocs@pge.com?subject=" + claimId}
        style={{ color: "#07679B" }}
        target="_blank"
        rel="noreferrer">
        {t('ConfirmationDocumentEmail')}{claimId}
      </a>.                                  
      </div>
      
      <div className="description">             
        {t('HelpDesk')}           
      </div>
      
      <div className="description">{t('Sincerely')}</div>
      <div className="description">{t('PGEClaimsTeam')}</div>
    </div>
  );
};
